import { TemplateVariablesHelpDialog } from '@/components/actions/TemplateVariablesHelpDialog'
import { FACEBOOK_LEADS_TEMPLATE_HELP } from '@/components/settings/facebookLeadsTemplateHelp'

type FacebookLeadsTemplateHelpDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  closeLabel?: string
}

export function FacebookLeadsTemplateHelpDialog({
  open,
  onOpenChange,
  closeLabel = 'Cerrar',
}: FacebookLeadsTemplateHelpDialogProps) {
  const help = FACEBOOK_LEADS_TEMPLATE_HELP

  return (
    <TemplateVariablesHelpDialog
      open={open}
      onOpenChange={onOpenChange}
      title={help.title}
      description={help.description}
      orderNote={help.orderNote}
      variablesTitle={help.variablesTitle}
      sourceLabel={help.sourceLabel}
      examplesTitle={help.examplesTitle}
      variables={[...help.variables]}
      examples={[...help.examples]}
      note={help.note}
      closeLabel={closeLabel}
    />
  )
}
